import axios from 'axios'
import { getCookie } from './cookie'
import { API_SERVER } from '../variables'

export const instance = axios.create({
  baseURL: API_SERVER,
  withCredentials: true,
  //   crossdomain: true,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'X-Client-App': 'Web',
    jwt: getCookie('jwt'),
    'accept' : '',
    // 'Content-Type': 'application/json',
  },
})

// Бэкенд закрыт авторизацией и лимитом уникальных доменов (100/сутки, 300/месяц;
// у новых недоверенных аккаунтов 30/70, тогда в payload limit.restricted = true).
// 401 у вошедшего — jwt протух, разлогиниваем: после перезагрузки гость видит форму входа
// прямо на странице (AuthRequired). 429 с code LIMIT_EXCEEDED — окно лимита.
// store подтягиваем лениво: store/modules импортируют этот файл, прямой импорт даст цикл
instance.interceptors.response.use(
  response => response,
  async error => {
    const status = error?.response?.status
    const data = error?.response?.data

    if (status === 401 || status === 429) {
      try {
        const { default: store } = await import('@/store')
        if (status === 401 && getCookie('jwt')) {
          store.commit('userInfo/logout')
        }
        if (status === 429 && data?.code === 'LIMIT_EXCEEDED') {
          store.commit('limits/open', data.limit)
        }
      } catch (err) {
        console.error('[api] cannot handle error response', err)
      }
    }

    return Promise.reject(error)
  }
)

// Имя ошибки для виджетов по ответу бэкенда
export const getApiErrorName = error => {
  const status = error?.response?.status
  const code = error?.response?.data?.code
  if (status === 401 || code === 'AUTH_REQUIRED') return 'authRequired'
  if (status === 429 && code === 'LIMIT_EXCEEDED') return 'limitExceeded'
  return null
}

const api = {}
api.get = (endpoint, params = {}, options = {}) => {
  return instance.get(endpoint, { params, ...options }).then(({ data }) => data)
}

api.post = (endpoint, body, options) => {
  return instance.post(endpoint, body, options).then(({ data }) => data)
}

api.delete = (endpoint, data, options) =>
  instance.delete(endpoint, { data }, options)
api.put = (endpoint, data) => instance.put(endpoint, data)
export { api }

window.api = api
